// removed by extract-text-webpack-plugin
module.exports = {"wrap":"PropertyCode-hashed__wrap__24yq9","left":"PropertyCode-hashed__left__2b_5D","right":"PropertyCode-hashed__right__1SfKb"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode-hashed.scss
// module id = 1227
// module chunks = 0